(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.factory('ThirdPartyApp', [ThirdPartyAppFn]);

    // model
    function ThirdPartyAppFn() {

        var ThirdPartyApp = function () {

            // default values
            this.id = 0;
            this.caption = null;
            this.url = null;
            this.fK_User = null;
            this.userDto = {};
        };

        // extend
        ThirdPartyApp.prototype.extend = function (object) {
            var self = this;
            angular.extend(self, object);
        };

        // prepare for save
        ThirdPartyApp.prototype.prepareForSave = function () {
            var self = this;


            self.fK_User = self.userDto ? self.userDto.id : null;

            delete self.userDto; //remove relation
            delete self.fK_Language; // from item
            delete self.vmEditable;
            delete self.vmIndex;
            delete self.vmNew;
        };

        return ThirdPartyApp;

    }
})();